import React, { useState } from 'react'
import DataTableContainer from '../../../common/components/DataTable/DataTableContainer'
import { Box, Typography } from '@mui/material'
import LoadingIndicator from '../../../common/components/LoadingIndicator'
import { useParams } from 'react-router-dom'
import StatusColumn from './StatusColumn'
import AttemptDetails from './AttemptDetails'
import dayjs from 'dayjs'

const convertToUserTimezone = serverTime => {
  const userTimezone = dayjs.tz.guess()
  const parsedTime = dayjs.utc(serverTime, 'YYYY-MM-DD HH:mm')
  return parsedTime.tz(userTimezone).format('MMMM DD, YYYY, HH:mm')
}

export default function UsersTrainingHistoryTable({ isLoading, data }) {
  const [selectedAttId, setSelectedAttId] = useState(false)
  const { id, userId } = useParams()

  const tableHeight = `calc(100vh - 368px)`

  const selectAttempt = id => {
    setSelectedAttId(id)
    // handleModulePreview(id)
  }

  const columns = [
    {
      field: 'trainingPackageName',
      headerName: 'Training Package Name',
      sortable: false,
      align: 'left',
      width: 190,
      renderComponent: (value, row) => (
        <Box
          sx={{ cursor: row.status == 'PASSED' ? 'auto' : 'pointer' }}
          onClick={() => (row.status == 'PASSED' ? null : selectAttempt(row.id))}
        >
          <Typography fontWeight={600} fontSize={'14px'} fontFamily={'Plus Jakarta Sans'}>
            {row.trainingPackageName}
          </Typography>
        </Box>
      )
    },
    {
      field: 'status',
      headerName: 'Status',
      sortable: false,
      align: 'left',
      width: 190,
      renderComponent: (value, row) => (
        <Box>
          <StatusColumn row={row} />
        </Box>
      )
    },

    {
      field: 'completedAt',
      headerName: 'Attempt Time',
      sortable: false,
      align: 'left',
      width: 190,
      renderComponent: (value, row) => (
        <Typography fontWeight={400} fontSize={'14px'} fontFamily={'Plus Jakarta Sans'} color={'#76767F'}>
          {convertToUserTimezone(row.completedAt)}
        </Typography>
      )
    }
  ]

  if (isLoading) {
    return (
      <Box display={'flex'} height={'100vh'} alignItems={'center'}>
        <LoadingIndicator />
      </Box>
    )
  }

  return (
    <Box width={'100%'} pt={'28px'} display={'flex'} flexDirection={'column'} rowGap={'20px'}>
      <Box width={'100%'} display={'flex'} justifyContent={'space-between'}>
        <Typography noWrap fontWeight={900} color={'#1B1B26'} fontFamily={'Satoshi'} fontSize={'24px'} pb={'8px'}>
          Attemts List
        </Typography>
      </Box>
      <DataTableContainer
        onRequestData={() => {}}
        // filter={filters}
        emptyText={'No attempts found'}
        config={{
          columns,
          stickyPagination: true,
          stickyHeader: true,
          height: tableHeight
        }}
        data={data}
        initialSort={{ orderBy: 'completedAt', order: 'asc' }}
        totalCount={data.length}
      />

      {selectedAttId && (
        <AttemptDetails
          attemptId={selectedAttId}
          userId={userId}
          trainingId={id}
          onClose={() => setSelectedAttId(null)}
        />
      )}
    </Box>
  )
}
